import React from "react";
import { FaInstagram, FaFacebook, FaTiktok, FaYoutube, FaSpotify } from "react-icons/fa";
import "./SocialMediaIcons.css"; // Import custom CSS for styling

const SocialMediaIcons = () => {
  return (
    <div className="social-icons-container">
      <a href="https://www.instagram.com/imagomundi_official" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaInstagram />
      </a>
      <a href="https://www.facebook.com/profile.php?id=61560224145071" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaFacebook />
      </a>
      <a href="https://www.tiktok.com/@imagomundi8" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaTiktok />
      </a>
      <a href="https://www.youtube.com/@imagomundiofficial" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaYoutube />
      </a>
      <a href="https://open.spotify.com/artist/4pD0Y4NqCiTWh4IhpH2NQO" target="_blank" rel="noopener noreferrer" className="social-icon">
        <FaSpotify />
      </a>
    </div>
  );
};

export default SocialMediaIcons;